import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/settings/audit')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['companySettings.readAudit'] }),
	component: Outlet,
});
